import main from '../components/main'
import login from '../pages/login'
import index from '../pages/index'
import searchList from '../pages/searchList'
import videoDetail from '../pages/videoDetail'
import collectionVideo from '../pages/collectionVideo'

export default {
    pages: [
      {
        path: '/',
        component: main,
        children: [
          {
              path: 'index',
              name: 'index',
              component: index
          },
          {
            path: 'searchList/:keyWord?/:date?/:sport?/:category?/:newDate?/:type?',
            name: 'searchList',
            component: searchList,
            meta: {
              keepAlive: true // 或根据条件设置
            }
          },
          {
            path: 'videoDetail/:id?',
            name: 'videoDetail',
            component: videoDetail
          },
          {
            path: 'collectionVideo/:id?',
            name: 'collectionVideo',
            component: collectionVideo
          }
        ]
      },
      {
        path: '/login/:sourceUrl?/:id?',
        name: 'login',
        component: login
      }
    ]
  }
